import { render, staticRenderFns } from "./AnswerPendency.vue?vue&type=template&id=2b020306&scoped=true&"
import script from "./AnswerPendency.vue?vue&type=script&lang=js&"
export * from "./AnswerPendency.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPendency.vue?vue&type=style&index=0&id=2b020306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b020306",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CDivider: require('@chakra-ui/vue').CDivider, CBox: require('@chakra-ui/vue').CBox, CGrid: require('@chakra-ui/vue').CGrid})
